import axios from 'axios';
import { getBlogPosts } from './Blog.action';

export class BlogDispatcher {
    requestPosts(dispatch) {
        axios.get('https://www.farmec.ro/compania/wp-json/wp/v2/posts?per_page=6')
            .then((res) => {
                dispatch(getBlogPosts(res));
            });
    }
}

export default new BlogDispatcher();
